import { useIntl } from 'react-intl'
import { Box, Flex, Text, Icon, Button, Heading } from '@homebotapp/hb-react-component-catalog'
import { HOMEOWNER_DIGEST_UPDATE_LOAN_WARNING_SECTION } from '../../../../constants/tracking/trackingEventLocations/homeownerDigestTrackingEventLocation'

export interface LoanUpdateWarningProps {
  btnTxt: { id: string; defaultMessage: string }
  bodyTxt: { id: string; defaultMessage: string }
  headerTxt: { id: string; defaultMessage: string }
  onClick: () => void
}

export const LoanUpdateWarning = ({ headerTxt, bodyTxt, btnTxt, onClick }: LoanUpdateWarningProps) => {
  const intl = useIntl()

  return (
    <Flex
      gap='4'
      borderRadius='.75rem'
      paddingX='8'
      paddingY='6'
      justify='space-between'
      marginTop='8'
      direction={['column', null, 'row']}
      align={['flex-start', null, 'center']}
      // @ts-ignore
      backgroundColor='var(--brand-surface-layer-50)'
    >
      {/* @ts-ignore */}
      <Icon width={6} height={6} name='info' color='var(--brand-secondary-accent-600)' />
      <Box>
        <Heading size='xs' textAlign='left' fontWeight='semibold'>
          {intl.formatMessage(headerTxt)}
        </Heading>
        <Text size='2xs'> {intl.formatMessage(bodyTxt)}</Text>
      </Box>
      <Button
        size='xs'
        flex='1 0 auto'
        variant='ghost'
        colorScheme='primary'
        onClick={onClick}
        tracking={{
          guid: 'voiEPbWEYBG4iqjNw5L41y',
          ui_context: HOMEOWNER_DIGEST_UPDATE_LOAN_WARNING_SECTION,
          descriptor: btnTxt.defaultMessage
        }}
      >
        {intl.formatMessage(btnTxt)}
      </Button>
    </Flex>
  )
}
